module.exports = __webpack_public_path__ + "static/map-b1f1d136792c43ed23e68c9da605dfa2.png";